import request from '../assets/js/utils/request'

// 普通登录
export function ApplyData(data){
  return request.post('/visit/addUser', data)
}

// 普通登录
export function VipAdd(data){
  return request.post('https://lencoronapi.ourproteinfactory.com/answer/PeBeauty/add', data)
}
// 普通登录
export function serialGet(data){
  return request.post('https://lencoronapi.ourproteinfactory.com/answer/PeBeauty/get', data)
}


export function verifyData(params) {
  return request({
    contentType: "json", 
    url: 'https://proapi.ourproteinfactory.com/check/'+params,
    method: 'post',
  })
}
export function otherProudun(data) {
  return request({
    url: 'https://apiprobio.ourproteinfactory.com/other/proudun ',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js